<div>

  <div class="cc-page-header">
    <div class="cc-page-header-title">
      <i class="pi pi-list"></i>
      <span>{{ 'CATALOG.INDEX' | translate }}</span>
      <span class="cc-page-header-subtitle" *ngIf="catalogName">— {{ catalogName }}</span>
    </div>
  </div>

  <div class="index-toolbar">
    <span class="index-total">{{ totalRecords }} celdas</span>
    <span class="index-hint" *ngIf="totalRecords > 0">
      <i class="pi pi-info-circle"></i>
      Las celdas vacías aparecen resaltadas
    </span>
  </div>

  <p-table
    [value]="rows"
    [lazy]="true"
    [filterDelay]="400"
    [paginator]="true"
    [rows]="pageSize"
    [totalRecords]="totalRecords"
    [loading]="loading"
    [rowsPerPageOptions]="[25, 50, 100]"
    (onLazyLoad)="onLazyLoad($event)"
    styleClass="p-datatable-sm p-datatable-striped p-datatable-gridlines"
    [rowHover]="true"
  >
    <ng-template pTemplate="header">
      <tr>
        <th pSortableColumn="fascicleName" style="width: 18%">
          {{ 'CATALOG.FASCICLE' | translate }} <p-sortIcon field="fascicleName" />
        </th>
        <th pSortableColumn="pageOrder" style="width: 7%">
          {{ 'CATALOG.PAGE' | translate }} <p-sortIcon field="pageOrder" />
        </th>
        <th pSortableColumn="cellOrder" style="width: 6%">
          {{ 'CATALOG.CELL' | translate }} <p-sortIcon field="cellOrder" />
        </th>
        <th pSortableColumn="templateName" style="width: 16%">
          {{ 'PAGE.TEMPLATE_NAME' | translate }} <p-sortIcon field="templateName" />
        </th>
        <th pSortableColumn="productSku">
          {{ 'PRODUCTS' | translate }} <p-sortIcon field="productSku" />
        </th>
        <th style="width: 3.5rem"></th>
      </tr>
      <tr>
        <th>
          <p-columnFilter field="fascicleName" matchMode="equals" [showMenu]="false">
            <ng-template pTemplate="filter" let-value let-filter="filterCallback">
              <p-dropdown
                [options]="fascicleOptions"
                [ngModel]="value"
                (ngModelChange)="filter($event)"
                placeholder="Todos"
                [showClear]="true"
                styleClass="w-full index-fascicle-filter"
                appendTo="body"
              />
            </ng-template>
          </p-columnFilter>
        </th>
        <th>
          <p-columnFilter field="pageOrder" matchMode="equals" [showMenu]="false">
            <ng-template pTemplate="filter" let-value let-filter="filterCallback">
              <input pInputText type="number" min="1" [ngModel]="value" (ngModelChange)="filter($event)"
                class="w-full p-inputtext-sm" placeholder="..." />
            </ng-template>
          </p-columnFilter>
        </th>
        <th></th>
        <th></th>
        <th>
          <p-columnFilter field="productSku" matchMode="contains" [showMenu]="false">
            <ng-template pTemplate="filter" let-value let-filter="filterCallback">
              <input pInputText type="text" [ngModel]="value" (ngModelChange)="filter($event)"
                class="w-full p-inputtext-sm" placeholder="..." />
            </ng-template>
          </p-columnFilter>
        </th>
        <th></th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-row>
      <tr [class.index-row-empty]="!row.productId">
        <td><span class="index-fascicle-name">{{ row.fascicleName }}</span></td>
        <td class="text-center">
          <p-tag [value]="row.pageOrder" severity="info" [rounded]="true" styleClass="text-xs" />
        </td>
        <td class="text-center text-color-secondary text-sm">#{{ row.cellOrder }}</td>
        <td class="text-color-secondary text-sm">{{ row.templateName }}</td>
        <td>
          <ng-container *ngIf="row.productId; else emptyCell">
            <code class="index-sku">{{ row.productSku }}</code>
            <span class="index-product-name">{{ row.productName }}</span>
          </ng-container>
          <ng-template #emptyCell>
            <span class="index-cell-empty">
              <i class="pi pi-minus-circle"></i> Vacía
            </span>
          </ng-template>
        </td>
        <td class="text-center">
          <p-button
            icon="pi pi-arrow-right"
            [rounded]="true"
            [text]="true"
            size="small"
            (onClick)="goToPage(row)"
            pTooltip="{{ 'CATALOG.GO_TO_PAGE' | translate }}"
          />
        </td>
      </tr>
    </ng-template>

    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="6" class="text-center text-color-secondary py-5">
          <i class="pi pi-inbox text-4xl mb-3 block opacity-40"></i>
          {{ 'CATALOG.INDEX_EMPTY' | translate }}
        </td>
      </tr>
    </ng-template>

    <ng-template pTemplate="paginatorright">
      <span class="text-sm text-color-secondary">
        {{ totalRecords }} {{ 'CATALOG.INDEX_RESULTS' | translate }}
      </span>
    </ng-template>
  </p-table>

</div>
